import React, { FC, useEffect, useState, useMemo } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { usePointBusinessStatisticsModel } from "../pointBusinessStatisticsModel";
import { IVRMPointBusinessStatisticsDetail } from "../pointBusinessStatisticsService";
import { formatNum } from "@/utils/utils";
import { useDictModel } from "@/views/base/dict/dictModel";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = usePointBusinessStatisticsModel();
    const { getTreeNodeName } = useDictModel(() => []);
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    useEffect(() => {
        loadData();
    }, [])

    const defaultColumns: ColumnsType<IVRMPointBusinessStatisticsDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            align: "center",
            render: (t, r, i) => i + 1
        }, {
            title: '站点',
            width: 200,
            dataIndex: 'customerName',
            render: text => <Tooltip placement="topLeft" title={text} arrowPointAtCenter><p className="ellipsis">{text}</p></Tooltip>
        }, {
            title: '进场维修车辆数量',
            width: 180,
            dataIndex: 'code',
        }, {
            title: '已竣工车辆数量',
            width: 100,
            dataIndex: 'tradeTypeName',
        }, {
            title: '未竣工车辆数量',
            width: 80,
            dataIndex: 'serviceTypeName',
        }, {
            title: '一保车辆数量',
            width: 80,
            dataIndex: 'payTypeName',
        }, {
            title: '二保车辆数量',
            width: 160,
            dataIndex: 'materialName',
        }, {
            title: '电车检查',
            width: 200,
            dataIndex: 'materialCode',
        }, {
            title: '救援方式',
            width: 160,
            dataIndex: 'typeName',
        }, {
            title: '救援数量',
            width: 100,
            dataIndex: 'num',
        }, {
            title: '备注',
            width: 100,
            dataIndex: 'price',
        },
    ];

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "orderDetailStatic", "roleCodes": roles };
        return getRoleColumns("orderDetailStatic", "主单", defaultColumns, params);
    }, [roles, dataSource]);
    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            bordered
            rowKey={record => record.id}
            // rowSelection={{
            //     selectedRowKeys: selectedRowKeys, //记录选中
            //     //全部选中时  (存string[])
            //     onSelectAll: (selected, selectedRows, changeRows) => {
            //         let changeRowId = changeRows.map(item => item.id);
            //         selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
            //             : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
            //     },
            //     onSelect: (record) => onRow(record.id),
            // }}
            columns={roleColumns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            // onRow={record => ({
            //     onClick: () => onRow(record.id)
            // })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 340px)' }}
        />
    )
}